<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form>
                    <c-form-item type="input" label="会员昵称" name="nick_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="会员手机号" name="user_manage_mobilephone" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="select" label="会员当前等级" name="user_level" options="USER_LEVEL_AUTH"></c-form-item>
                    <c-form-item type="select" label="会员可升至" name="upgrade_level" options="MEMBER_LEVEL_AUTH"></c-form-item>
                    <c-form-item type="input" label="邀请人昵称" name="share_nick_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="邀请人手机号" name="share_user_manage_mobilephone" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="checkbox" label="会员状态" name="state" :options="stateType"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button color="m" hollow @click="updateState()">批量审核</c-button>
			</m-operate>

            <c-table ref="table">
                <c-table-column type="selector" ></c-table-column>

                <c-table-column
                    label="会员头像/昵称/等级"
                    name="head_photo"
                    width="200"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{data.nick_name}}</span></br>
                                <span style="color:blue">{{data.user_level_name}}</span>
                            </div>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                    label="会员手机号"
                    name="user_manage_mobilephone"
                    width="110"
                >
                    <template v-slot="{data}">
                        <span>{{data.user_manage_mobilephone||'-'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="会员可升至"
                        name="upgrade_level_name"
                        width="110"
                >
                    <template v-slot="{data}">
                        <span v-if="data.upgrade_level_name" style="color: blue">{{data.upgrade_level_name}}</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                    label="会员成长等级"
                    name="growth_level_name"
					v-if="systemConfig.growth_enable == 'ON'"
                    width="100"
                >
                  <template v-slot="{data}">
                      <span v-if="data.growth_level_name" style="color: blue">{{data.growth_level_name}}</span>
                      <span v-else>-</span>
                  </template>
                </c-table-column>
				
				<c-table-column
				    label="会员成长值"
				    name="growth_value"
					v-if="systemConfig.growth_enable == 'ON'"
				    width="95"
				>
				  <template v-slot="{data}">
				      {{data.growth_value}}
				  </template>
				</c-table-column>

				<c-table-column
				    label="邀请人头像/昵称/等级"
				    name="head_photo"
					v-if="systemConfig.share_enable == 'ON'"
				    width="200"
				>
                    <template v-slot="{data}">
                        <div class="flex-center-cross" v-if="data.platform_user_id > 0">
                            <c-image :src="data.share_user_head_photo" preview size="40" style="margin-right: 10px;"></c-image>
                            <div>
                                <span>{{data.share_user_nick_name}}</span></br>
                                <span style="color:blue">{{data.share_user_level_name}}</span>
                            </div>
                        </div>
                        <span v-else>--</span>
                    </template>
				</c-table-column>

                <c-table-column
                        label="邀请人手机号"
                        name="share_user_manage_mobilephone"
                        width="110"
                >
                    <template v-slot="{data}">
                        <span>{{data.share_user_manage_mobilephone||'-'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
					label="会员业绩数量"
					name="performance_count"
					width="100"
                >
                </c-table-column>

                <c-table-column
					label="会员业绩金额"
					name="performance_money"
					width="100"
                >
                    <template v-slot="{data}">
                        <span>
                            ￥{{parseFloat(data.performance_money).toFixed(2)}}
                        </span>
                    </template>
                </c-table-column>

                <c-table-column
					label="会员状态"
					name="state"
					width="80"
                >
					<template v-slot="{data}">
						<span v-if="data.state == 1" style="color:darkgreen">启用</span>
						<span v-if="data.state == 2" style="color:red">禁用</span>
					</template>
                </c-table-column>

                <c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
                >
					<template v-slot="{data}">
						<c-table-button @click="detail(data)">详情</c-table-button>
						<c-table-button power="b_member_upgrade_approve" v-if="data.user_level = -99 && data.upgrade_level_name" @click="updateState(data)">
                            升级审批
                        </c-table-button>
					</template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
	import {mapState} from 'vuex'
    export default {
		name: 'm_member_upgrade',
        components: {
        },
		data() {
			return {
                workType:12,
                searchParams:{},
				editState: false,   //编辑或是新增  true=编辑  false=新增
				userResourceMap: {
                      'OMS':'管理后台',
                      'PC':'PC电脑',
                      'IOS':'苹果APP',
                      'ANDROID':'安卓APP',
                      'MINI':'微信小程序',
                      'RETAIL_MINI':'微信小程序',
                      'BARGAIN':'砍价页',
                      'H5':'H5页'
				},
				stateType:[
					{
						name:'启用',
						value:1
					},{
						name:'禁用',
						value:2
					}
				],
				liquidationType:[
				  {
				    name:'发货后',
				    value:1
				  }, {
				      name:'确认收货后',
				      value:2
				  }
				],
				current_user_level:-1,//当前选中的等级
				user_level_list:[],//会员等级列表
				current_salesman:'',//当前选中的业务员
				salesman_list:[]//业务员列表
			}
		},
		computed: {
			...mapState(['systemConfig', 'userInfo']),
		},
		mounted() {
			this.$refs.search.search();
		},

		methods: {
            searchHandle(data) {
                data.is_upgrade_approve = 1;//仅查询需要升级的会员
                this.$refs.table.load({
                    url: '/platform_user/list',
                    data
                });
                this.searchParams = data||{};
            },

            //查询会员详情
            detail(val) {
                this.navigateTo({
                    path: '/member_detail/' + val.platform_user_id,
                });
            },

            //更新会员状态
            updateState(data) {
                var platform_user_ids = [];
                var msg = "";
                if (data){
                    msg = '是否确定将会员【' + data.user_manage_mobilephone + '】升级成为【'+data.upgrade_level_name+'】代理？';
                    platform_user_ids.push(data.platform_user_id);
                }else {
                    //批量操作
                    var list = this.$refs.table.getRow('selected');
                    if (!list.length) {
                        this.$message({
                            text: '请选择要处理的申请记录'
                        });
                        return;
                    }
                    platform_user_ids = Array.from(list, item => {
                        return item.data.platform_user_id;
                    });
                    msg = '是否确定将选择的【' + platform_user_ids.length + '个会员】升级成为代理？具体升级等级将根据业绩自动判断。';
                }
                this.$confirm({
                    text: msg,  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/platform_user/upgrade_agency',
                            data: {
                                platform_user_ids: platform_user_ids
                            },
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '审批发送成功，调整结果可能稍有延迟，请自行刷新列表',
                                    icon: 'success'
                                });
                                //延迟刷新页面
                                setTimeout(() => {
                                    this.$refs.table.update();
                                }, 1000);
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {
                    },  // 取消按钮回调
                });
            }
        }
	}
</script>